"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcadeService = void 0;
const config_1 = require("../config/config");
const games_1 = require("../models/games");
const api_1 = require("./api");
const PATH = 'game/api';
class ArcadeService {
    static async getArcadeGames(sort) {
        const gameType = config_1.react_core_config.internalConfig.arcadeGameType;
        const requestParams = sort ? `sort=${sort}` : '';
        const url = `${PATH}/published-games?gameTypeId.in=${gameType}&${requestParams}`;
        const response = await api_1.API.get({ url });
        const parsedGames = games_1.Game.JsonToGames(response.content);
        return {
            parsedGames
        };
    }
}
exports.ArcadeService = ArcadeService;
//# sourceMappingURL=arcade-service.js.map